import { createSlice } from "@reduxjs/toolkit";
import * as marginActions from "./marginActions";

const InitialState = {
    isLoading: false,
    vendorAndBoxigoMargin: [],
    hasError: false,
};

const marginReducer = createSlice({
    name: "vendorAndBoxigoMargin",
    initialState: InitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(marginActions.getVendorBoxigoMarginRecord.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(marginActions.getVendorBoxigoMarginRecord.fulfilled, (state, action) => {
                state.vendorAndBoxigoMargin = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(marginActions.getVendorBoxigoMarginRecord.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
            .addCase(marginActions.createVendorBoxigoMarginRecord.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(marginActions.createVendorBoxigoMarginRecord.fulfilled, (state, action) => {
                state.vendorAndBoxigoMargin = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(marginActions.createVendorBoxigoMarginRecord.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
            .addCase(marginActions.updateVendorBoxigoMarginRecord.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(marginActions.updateVendorBoxigoMarginRecord.fulfilled, (state, action) => {
                state.vendorAndBoxigoMargin = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(marginActions.updateVendorBoxigoMarginRecord.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
    },
});

export default marginReducer.reducer;